import React from 'react'
import { Navigate } from 'react-router-dom';
import useAuthStore from '../store/auth';

export default function UnAuthenticated({ children }) {
  const authenticated = useAuthStore((state) => state.authenticated);
  const isAuthenticated = authenticated;
  return !isAuthenticated ? children : <Navigate to='/account/dashboard' />
}
